module.exports = __webpack_public_path__ + "img/P2-A8.9736f00a.svg";